import React, { useState, useEffect } from "react";
import Konami from "konami-code-js";
import GameModal from "./GameModal";

const EasterEgg = () => {
  const [showGame, setShowGame] = useState(false);

  useEffect(() => {
    new Konami(() => {
      document.body.classList.add("crumble-mode");
      setTimeout(() => {
        setShowGame(true);
        document.body.classList.remove("crumble-mode");
      }, 2500);
    });
  }, []);

  return showGame ? <GameModal onClose={() => setShowGame(false)} /> : null;
};

export default EasterEgg;
